import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get audio List
export const getAudioList = createAsyncThunk(
  "getAudioList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`/audio/get-audio${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create Edit audio
export const createAudio = createAsyncThunk(
  "createAudio",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`/audio/add-audio`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const editAudio = createAsyncThunk(
  "editAudio",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`/audio/update-audio`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete audio
export const deleteAudio = createAsyncThunk(
  "deleteAudio",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/audio/delete-audio/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const audioSlice = createSlice({
  name: "audio",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get audio list
      .addCase(getAudioList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAudioList.fulfilled, (state, action) => {
        state.loading = false;
        state.getAudioListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAudioList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create audio
      .addCase(createAudio.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAudio.fulfilled, (state, action) => {
        state.loading = false;
        state.createAudioStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createAudio.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //Edit audio
      .addCase(editAudio.pending, (state) => {
        state.loading = true;
      })
      .addCase(editAudio.fulfilled, (state, action) => {
        state.loading = false;
        state.editAudioStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editAudio.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete audio
      .addCase(deleteAudio.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAudio.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteAudioStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteAudio.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setAudio } = audioSlice.actions;
export default audioSlice.reducer;
